export const timePattern = /^[0-9]+:?[0-5]?[0-9]?$/;

export const clockTimePattern = /^(?:[01]\d|2[0-3]):[0-5]\d$/;
